var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"teal darken-1","dark":"","app":""}},[_c('span',[_vm._v("© 2019")])])
}
var staticRenderFns = []

export { render, staticRenderFns }